import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'event-list',
  name: '活动列表',
  icon: '活',
  group: '校友会组件',
  description: '展示返校、聚会、讲座等校友活动。',
  defaultProps: {
    title: '近期活动',
    limit: 4
}
}
